import { TYPE_DEFAULT } from '@videotools/js/api/entities/TagGroup';

const properties = [
	'id',
	'tag',
	'name',
	'type',
	'order',
	'secondsBefore',
	'secondsAfter',
	'priority',
	'timeline',
	'labelType',
	'highlight',
	'analysisOnly',
	'target',
	'section',
];

export const TAG_TARGET_EVENT = 'event';
export const TAG_TARGET_TEAM = 'team';
export const TAG_TARGET_PLAYER = 'player';
export const TAG_TARGET_ANY = 'any'; // TODO: deprecated

export const TAG_TYPE_DEFAULT = 'default';
export const TAG_TYPE_CUSTOM = 'custom';
export const TAG_TYPE_CLOCK = 'clock';

export const TAG_NAME_CLOCK_START = 'clock_start';
export const TAG_NAME_CLOCK_STOP = 'clock_end';
export const TAG_NAME_CLOCK_SET = 'clock_set';
export const TAG_NAME_GOAL = 'goal';
export const TAG_NAME_1ST_RUN_START = '1st_run_start';
export const TAG_NAME_2ND_RUN_START = '2nd_run_start';
export const TAG_NAME_RACE_START = 'race_start';
export const TAG_NAME_RACE_END = 'race_end';
export const TAG_NAME_CUT = 'cut';
export const TAG_NAME_RUN = 'run';

// ice hockey penalties
export const TAG_NAME_ACTION_2_MINUTES = '2_minutes';
export const TAG_NAME_ACTION_5_MINUTES = '5_minutes';

export const TAG_NAMES = {
	[TAG_TYPE_CLOCK]: [TAG_NAME_CLOCK_START, TAG_NAME_CLOCK_STOP, TAG_NAME_CLOCK_SET],
};

/**
 * @property id
 * @property name
 * @property section
 * @property type
 * @property order
 */
export default class TagButton {
	constructor(props = {}) {
		for (const key of properties) {
			if (key in props) {
				this[key] = props[key];
			}
		}
		if (!this.id) {
			this.id = this.generateId();
		}
	}

	generateId() {
		return `new-${Date.now()}-${Math.round(Math.random() * 1000)}`;
	}

	get isNew() {
		return this.id?.toString().startsWith('new-');
	}

	isParticipantTag() {
		return [TAG_TARGET_PLAYER, TAG_TARGET_TEAM, TAG_TARGET_ANY].includes(this.target);
	}

	isMatchTag() {
		return this.target === TAG_TARGET_EVENT && this.type === TYPE_DEFAULT;
	}

	get isCustom() {
		return this.type === TAG_TYPE_CUSTOM;
	}
}
